import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  TopToolbar,
  CreateButton,
  EditButton,
} from 'react-admin';

import { DateField } from './DateField';
import { BooleanField } from './BooleanField';
import { ChipField } from './ChipField';

const BannerListActions = () => {
  return (
    <TopToolbar>
        <CreateButton
          basePath="/banners"
          variant="contained"
          label="New Banner"
        />
    </TopToolbar>
  );
};

const BannerList = (props) => {
  return (
    <List
      {...props}
      actions={<BannerListActions />}
      bulkActionButtons={false}
    >
      <Datagrid>
        <TextField source="raw_name" label="Nome genérico" />
        <ChipField source="type" label="Tipo" size="small" />
        <BooleanField
          source="active"
          label="status"
          falsyValueLabel="Não ativo"
          truthyValueLabel="Ativo"
        />
        <TextField source="priority" label="Prioridade" />
        <DateField source="date_start" label="Data Ínicio" />
        <DateField source="date_end" label="Data Fim" />
        <EditButton />
      </Datagrid>
    </List>
  );
}

export default BannerList;